module.exports = __webpack_public_path__ + "media/ציור.a9341621.mp3";